import {HttpStatusCode} from "axios";

interface ErrorResponseInterface {
    status: HttpStatusCode;
    message: string;
    detail?: string
    field?: string
}

class ErrorResponse implements ErrorResponseInterface {
    detail: string;
    field: string;
    message: string;
    status: HttpStatusCode;

    constructor(
        status: HttpStatusCode,
        message: string,
        detail?: string,
        field?: string,
    ) {
        this.status = status;
        switch (status) {
            case HttpStatusCode.InternalServerError:
                this.message = "Internal server error";
                this.detail = "На севере произошла ошибка";
                break;
            case HttpStatusCode.BadGateway:
                this.message = "Bad gateway";
                this.detail = "Не удается соединиться с сервером";
                break;
            default:
                this.message = message;
                this.detail = detail;
        }
        this.field = field;
    }
}

export default ErrorResponse